import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetCoursesQuery } from "../../hooks/useGetCoursesQuery";
import { setUpdateCourseData } from "../../redux/slices/school/course";
import { routes } from "../../routes";
import { deleteCourse } from "../../services/school/course/deleteCourse";
import { CourseType } from "../../types/Course";
import { setPreviousPath } from "../../redux/slices/previousPath";
import { getCoursesSubjects } from "../../services/school/courseSubject/getCoursesSubjects";
import { PAGE_NUMBER, PAGE_SIZE } from "../../utils/constants";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";

const columnNamesMap: { [key: string]: string } = {
    name: 'Curso',
    departament: 'Departamento',
};
export const Courses = () => {
    const [currentPage, setCurrentPage] = useState(PAGE_NUMBER);
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const [itemToBeDeleted, setItemToBeDeleted] = useState<CourseType | null>(null);
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetCoursesQuery({
        PageNumber: currentPage, PageSize: pageSize, SearchTerm: searchTerm
    });

    const mutationDeleteCourse = useMutation(deleteCourse, {
        onSuccess: () => {
            queryClient.invalidateQueries('courses-pagination');
            toast.success('Curso eliminado');
        },
        onError: () => {
            toast.error("Erro ao eliminar o curso.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handlePageSizeChange = (size: number) => {
        setPageSize(size);
        setCurrentPage(PAGE_NUMBER);
    };

    const handleSearch = (term: string) => {
        setSearchTerm(term);
        setCurrentPage(1);
    };

    const handleClickCreate = (event: any): void => {
        navigate(routes.createCourse)
    }
    const handleEdit = (course: CourseType) => {
        dispatch(setUpdateCourseData(course));
        navigate(routes.updateCourse)
    };
    const handleDelete = (course: CourseType) => {
        mutationDeleteCourse.mutateAsync({ id: course.id })
    };

    const openDeleteDialog = (course: CourseType) => {
        setItemToBeDeleted(course);
    };

    const confirmDelete = () => {
        if (itemToBeDeleted) {
            handleDelete(itemToBeDeleted);
        }
    };

    const handleAssignManagers = (course: CourseType) => {
        dispatch(setUpdateCourseData(course));
        dispatch(setPreviousPath(routes.courses))
        navigate(routes.assignManager)

    };
    const handleCurriculumGrid = (course: CourseType) => {
        dispatch(setUpdateCourseData(course));
        dispatch(setPreviousPath(routes.courses))
        navigate(routes.curriculumGrid)
    };
    const handleCreateCourseSubject = async (course: CourseType) => {
        try {
            const { items } = await getCoursesSubjects({ PageSize: 1000, PageNumber: 1, IdCourse: course.id })
            course.courseSubjects = items;
            dispatch(setUpdateCourseData(course));
            dispatch(setPreviousPath(routes.courses))
            // navigate(routes.courseSubjectV2)
        } catch (ex) {
            console.error(ex);
        }
    };

    const options = data?.items.map(() => [
        {
            label: 'Editar',
            onClick: (course: CourseType) => handleEdit(course),
            icon: <Pencil1Icon />
        },
        {
            label: 'Vincular responsável',
            onClick: (departament: CourseType) => handleAssignManagers(departament),
            icon: <Pencil1Icon />
        },
        {
            label: 'Gerir grelha curricular',
            onClick: (course: CourseType) => handleCreateCourseSubject(course),
            icon: <Pencil1Icon />
        },
        {
            label: 'Grelha curricular',
            onClick: (course: CourseType) => handleCurriculumGrid(course),
            icon: <Pencil1Icon />
        },
        {
            label: 'Eliminar',
            onClick: (course: CourseType) => openDeleteDialog(course),
            icon: <TrashIcon />
        }
    ]) || [];

    return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        pageSize={pageSize}
                        onPageSizeChange={handlePageSizeChange}
                        onSearch={handleSearch}
                        search={searchTerm}
                        totalItems={data?.totalItems || 0}
                    />
                }
                handleClickCreate={handleClickCreate}


            />

            <ConfirmAlertDialog
                open={!!itemToBeDeleted}
                onOpenChange={(open) => !open && setItemToBeDeleted(null)}
                title="Eliminar curso"
                description={`Pretende eliminar o curso ${itemToBeDeleted?.name} - ${itemToBeDeleted?.code}? Esta operação é irreversível.`}
                confirmLabel="Eliminar"
                item={itemToBeDeleted}
                onConfirm={confirmDelete}
                onCancel={() => setItemToBeDeleted(null)}
            />

        </>
    );
}